export enum EngagementTemplateFlowStepEnum {
  CHOOSE_RECIPIENT_SENDER = 'CHOOSE_RECIPIENT_SENDER',
  CHOOSE_TEMPLATE_MESSAGE = 'CHOOSE_TEMPLATE_MESSAGE',
  COMPOSE_MESSAGE = 'COMPOSE_MESSAGE',
  PREVIEW_AND_SEND_MESSAGE = 'PREVIEW_AND_SEND_MESSAGE',
  CHOOSE_WRITE_MESSAGE = 'CHOOSE_WRITE_MESSAGE',
}
